export default __webpack_public_path__ + "static-bigflip/media/deed-of-articles-of-association.19adfc2b.png";